import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

import { ThemeProvider } from 'vue3-styled-components';
import { VueQueryDevTools } from 'vue-query/devtools';
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import * as layouts from '@/entities/app/components/layouts';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();
const layout = computed(() => layouts[router.currentRoute.value.meta.layout || 'DefaultLayout']);
const path = computed(() => router.currentRoute.value.path);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(ThemeProvider), null, {
    default: _withCtx(() => [
      _createVNode(_unref(VueQueryDevTools)),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(layout)), null, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_component_router_view, { key: _unref(path) }))
        ]),
        _: 1
      }))
    ]),
    _: 1
  }))
}
}

})